var _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#102633",
    stroke: "#102633",
    strokeWidth: 15,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#102633",
    stroke: "#102633",
    strokeWidth: 15,
    opacity: 0.8,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.05
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#102633",
    stroke: "#102633",
    strokeWidth: 15,
    opacity: 0.6,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#102633",
    stroke: "#102633",
    strokeWidth: 15,
    opacity: 0.4,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.15
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#102633",
    stroke: "#102633",
    strokeWidth: 15,
    opacity: 0.2,
    r: 15,
    cx: 35,
    cy: 100
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    calcMode: "spline",
    dur: 2,
    values: "35;165;165;35;35",
    keySplines: "0 .1 .5 1;0 .1 .5 1;0 .1 .5 1;0 .1 .5 1",
    repeatCount: "indefinite",
    begin: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.80c3ebf6d91d2fa853089d6bb0a514a0.svg";
export { ForwardRef as ReactComponent };